






































import Vue from "vue";
import firebaseApp from "@/main";

export default Vue.extend({
  name: "ForgotPassword",
  data: () => ({
    valid: false,
    overlayLoader: false,
    // Email Validation
    email: "",
    emailRules: [
      (v: any) => !!v || "E-mail is required",
      (v: any) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
  }),
  methods: {
    async sendRecoveryEmail() {
      if (this.valid) {
        this.overlayLoader = true;
        let msg = "";
        await firebaseApp
          .auth()
          .sendPasswordResetEmail(this.email)
          .then(() => {
            msg = "Recovery Email Sent";
          })
          .catch((err) => {
            if (err.code === "auth/user-not-found")
              msg = "There is not a user with that email";

            if (err.code === "auth/invalid-email")
              msg = "Email formatting is not correct";
          });
        this.overlayLoader = false;
        alert(msg);
      } else alert("Make sure the email you enterd is correct ");
    },
  },
});
